<template>
  <div class="b2b-grid-flex b2b-grid--collapse">

    <!-- Each Header -->
    <div v-for="(header, index) in gridData.header"
      :key="index"
      :data-type="`${header.type}`"
      :class="`w-${header.size}`"
      class="b2b-grid-flex__cell b2b-grid__head hidden lg:block">
      {{ header.label }}
    </div>

    <!-- Each Row -->
    <template v-for="(row, rowIndex) in gridData.row">

      <!-- Each Cell -->
      <template v-for="(rowData, dataIndex) in row.data">
        <div class="b2b-grid-flex__label">
            {{ gridData.header[dataIndex].label }}
        </div>

        <div class="b2b-grid-flex__cell b2b-grid__content"
          :data-type="`${rowData.type}`"
          :class="[
            `w-${gridData.header[dataIndex].size}`,
            dataIndex,
            { 'b2b-grid-flex__cell--dark' : rowIndex % 2 !== 0 },
          ]">
          <grid-icon v-if="rowData.type === 'icon'" :data="rowData"></grid-icon>
          <grid-warehouse v-else-if="rowData.type === 'warehouse'" :data="rowData"></grid-warehouse>
          <grid-stock-watch v-else-if="rowData.type === 'stock-watch'" :data="rowData"></grid-stock-watch>
          <grid-price v-else-if="rowData.type === 'price'" :data="rowData.value"></grid-price>
          <grid-input v-else-if="rowData.type.startsWith('input-')" :data="rowData"></grid-input>
          <grid-switch v-else-if="rowData.type === 'toggle-switch'" :data="rowData"></grid-switch>          
          <grid-text v-else :data="rowData"></grid-text>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    gridData: Object
  }
};
</script>
